var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 13.333a.643.643 0 0 1-.474-.192.644.644 0 0 1-.192-.474v-7.45l-3.25 3.25a.65.65 0 0 1-.476.2.649.649 0 0 1-.474-.2.64.64 0 0 1 0-.933l4.4-4.4a.589.589 0 0 1 .216-.143.82.82 0 0 1 .509 0 .454.454 0 0 1 .208.142l4.4 4.4c.133.134.2.29.2.467s-.067.333-.2.467a.65.65 0 0 1-.475.2.649.649 0 0 1-.475-.2l-3.25-3.25v7.45a.645.645 0 0 1-.191.474.646.646 0 0 1-.476.192z","fill":"currentColor"}));
}

ArrowUp.defaultProps = {"fill":"none","height":"16","viewBox":"0 0 16 16","width":"16"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
